import React, { useState } from "react"; 

const CharacterListItem = ({ characterItem,
    setCharacters, setSavedCharacters,
    characters, setSelectedCharacter,
    setSelectedView, setIsEditing,
    createCharacterAction }) => {

    const [isDeleting, setIsDeleting] = useState(false);

    const handleDisplay = () => {
        if (characterItem !== null) {
            setSelectedCharacter(characterItem);
            setSelectedView("DISPLAY_CHARACTER");
        } else {
            createCharacterAction();
        }
    };

    function checkShouldDelete() {
        if (isDeleting) {
            handleDelete();
        }
    }

    const beginDelete = (e) => {
        e.stopPropagation();
        setIsDeleting(true);
    }

    const handleDelete = (e) => {
        setCharacters(
            characters.filter(function (charItem) { 
                return charItem.id !== characterItem.id
            })
        );

        var charArray = [...characters];
        var index = charArray.indexOf(characterItem);
        if (index !== -1) {
            charArray.splice(index, 1);
            setCharacters(charArray);
            setSavedCharacters(charArray);
        }
    };

    function characterName() {
        return characterItem !== null
            ? characterItem.name : "Create character";
    }

    // portrait

    function characterPortraitURL() {
        if (characterItem !== null) {
            return "MCBP/" + characterItem.portraitName + ".png";
        }
        return "MCBP/MCBP5.png";
    }

    // class names

    function classNames(classes) {
        return Object.entries(classes)
            .filter(([key, value]) => value)
            .map(([key, value]) => key)
            .join(' ');
    }

    const cardClasses = {
        'Character-list-card': true,
        'Character-list-card-create': characterItem === null,
        'Character-list-card-shrink': isDeleting
    };

    const cardClassNames = classNames(cardClasses);

    function CardCharacterNameClassName() {
        return characterItem !== null ? "Character-list-row-name" : "Character-list-row-name-create";
    }

    return (
        <div className={cardClassNames}
            key={characterItem !== null ? characterItem.id : 0}
            onClick={handleDisplay}
            onAnimationEnd={checkShouldDelete}
        >
                <div className="App-card-characterpicture"
                    style={{
                        backgroundImage:
                            `url(${process.env.PUBLIC_URL + '/' + characterPortraitURL()})`
                    }}>
                </div>
            <span className={CardCharacterNameClassName()}>
                {characterName()}</span>
            {characterItem !== null && (
                <button className="Character-list-row-button button-top-right"
                    onClick={beginDelete} >
                    DELETE
                </button>)}
        </div>
    );
};

export default CharacterListItem;